import {useIonViewWillEnter, useIonViewWillLeave} from "@ionic/react";
import {type DependencyList, type EffectCallback, useEffect, useState} from "react";

export const useIonViewEffect = (effect: EffectCallback, deps: DependencyList): void => {
  const [isViewActive, setIsViewActive] = useState(false);

  useIonViewWillEnter(() => {
    setIsViewActive(true);
  }, []);

  useIonViewWillLeave(() => {
    setIsViewActive(false);
  }, []);

  useEffect(
    () => {
      if (!isViewActive) return;
      return effect();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isViewActive, ...deps]
  );
};
